import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Log } from 'app/core/logging/log';
import { TextContentModel, TranslationModel } from 'app/models/text-content-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';


@Component({
  selector: 'app-admin-literal',
  templateUrl: './admin-literal.page.html',
  styleUrls: ['./admin-literal.page.scss'],
})
export class AdminLiteralPage implements OnInit {

  literals: TextContentModel[] = [];
  displayedColumns: string[] = ['originText', 'translation', 'lang'];
  totalElements = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  constructor(
    private restService: RestService,
    private appService: AppService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.getLiterals();
  }


  getLiterals({ page = this.pageIndex, size = this.pageSize }: { page?: number; size?: number; } = {}) {
    const parameters = `page=${page}&size=${size}`;
    this.restService.getLiterals(parameters).subscribe(result => {
      this.literals = result.content;
      this.totalElements = result.totalElements ?? result.content?.length ?? 0;
      this.pageSize = result.pageSize ?? size;
      this.pageIndex = result.pageNumber ?? page;
    });
  }

  onPageChange(event: PageEvent) {
    this.getLiterals({ page: event.pageIndex, size: event.pageSize });
  }

  get visibleLiterals(): number {
    return this.literals?.length || 0;
  }

  openDetails(literal?: TextContentModel) {
    Log.debug('literal', {literal});

    let isNew: boolean = false;
    if (literal == null) {
      isNew = true;
      literal = {
        id: 0,
        originText: '',
        translations: [],
        createdAt: '',
        updatedAt: ''
      }
    }

    this.dialog.open(LiteralDetailsModalContent, {
      panelClass: 'responsive-dialog',
      maxWidth: '95vw',
      data: { literal, isNew }
    }).afterClosed().subscribe((data) => {
      if (!data) {
        return;
      }
      Log.debug('data', data);
      this.getLiterals();
    });
  }

  displayLangCode(literal: TextContentModel){
    let result = [];
    if(literal){
      literal.translations.forEach(element => result.push(element.lang.name));
    }
    return result;
  }

  getPrimaryTranslation(literal: TextContentModel): string {
    return literal?.translations?.[0]?.translation || '-';
  }

  getTranslationPreview(literal: TextContentModel, maxLength = 120): string {
    const translation = this.getPrimaryTranslation(literal);

    if (!translation || translation.length <= maxLength) {
      return translation;
    }

    return `${translation.slice(0, maxLength).trim()}...`;
  }

  getTranslationCount(literal: TextContentModel): number {
    return literal?.translations?.length || 0;
  }


}

@Component({
  selector: 'app-admin-literal-details-modal-content',
  templateUrl: './admin-literal-details.modal.html',
  styleUrls: ['./admin-literal-details.modal.scss']
})
export class LiteralDetailsModalContent implements OnInit {
  literal: TextContentModel;
  isNew: boolean;
  langToAdd: any;

  constructor(
    public activeModal: MatDialogRef<LiteralDetailsModalContent>,
    @Inject(MAT_DIALOG_DATA) public data: { literal: TextContentModel; isNew: boolean },
    private restService: RestService,
    public appService: AppService) {
      this.literal = data?.literal;
      this.isNew = data?.isNew;
  }


  ngOnInit(): void {
    Log.debug('jobParamenter', {literal: this.literal});
    Log.debug('isNew', {isNew: this.isNew});
  }

  cancel() {
    this.activeModal.close();
  }

  confirm() {
    Log.debug('confirm', {literal: this.literal});

    if (this.isNew) {
      this.createLiteral();
    } else {
      this.updateLiteral();
    }

  }

  createLiteral() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.createLiteral(this.literal).subscribe(result => {
      this.activeModal.close(true);
    });
  }

  updateLiteral() {

    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.updateLiteral(this.literal).subscribe(result => {
      this.activeModal.close(true);
    });
  }

  deleteLiteral() {
    if (!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.deleteLiteral(this.literal.id).subscribe(result => {
      this.activeModal.close(true);
    });
  }

  getLangs(){
    return AppService.langs;
  }

  addTranslation(){
    let translation = {
      textContentId: this.literal.id,
      langId: this.getLangs().find(f=>f.landId==this.langToAdd).landId,
      lang: this.getLangs().find(f=>f.landId==this.langToAdd),
      translation: '',
      createdAt: null,
      updatedAt: null
    }
    Log.debug('addLang', {literal: this.literal});
    this.literal.translations.push(translation);
    Log.debug('addLang', {literal: this.literal});
  }

  deleteTranslation(translation: TranslationModel){
    let index = this.literal.translations.findIndex(i=> i.lang.landId == translation.lang.landId);
    this.literal.translations = this.literal.translations.splice(index, 1);
    Log.debug('deleteTranslation', {literal: this.literal, index});
  }
}
